import { useEffect, useState } from "react";
import AfterLoginHeader from "../../components/header/AfterLoginHeader";
import { useSelector } from "react-redux";
import { userSelector } from "../../store/userSlice";
import { getReferalListingsNew } from "../../api_services/api_calls/referralAgentListingApi";
import Skeleton from "react-loading-skeleton";
import { VIEWLISTING } from "../../constants/imagepath";
import { Link } from "react-router-dom/cjs/react-router-dom";
import Footer from "../../components/footer/Footer";
const ReferalListings = () => {
    const { userData } = useSelector(userSelector);

    const [referalListings, setReferalListings] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        getReferalListingsNew()
            .then((response) => {
                console.log("getReferalListings response", response.data);

                setReferalListings(response.data?.data);
            })
            .catch((error) => { })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return (
        <>
            <AfterLoginHeader userData={userData} />
            <section
                className="section ct_billing_hidtory_pt_top   "
                style={{ backgroundColor: "#F9F9F9" }}
            >
                <div className="container mt-5 pt-4">
                    {loading ? (
                        <Skeleton count={5} />
                    ) : (
                        <div className="sell_listing_box">
                            <div className="list-wrapper">
                                <div className="list-item">
                                    <section className="section3">
                                        <div className="flex-container">
                                            <div className="member table-responsive">
                                                <h2>List of Referals</h2>
                                                <table className="content-member lising_table mt-3 w-100">
                                                    <thead>
                                                        <tr className="name-row">
                                                            <th>S.No.</th>
                                                            <th>Client name</th>
                                                            {/* <th>Client Email</th> */}
                                                            <th>Client Phone</th>
                                                            <th>Listing Type</th>
                                                            <th>Listing / Request Id</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {referalListings?.length === 0 ? (
                                                            <tr>
                                                                <td className="edit" colSpan={5}>
                                                                    {" "}
                                                                    <h4> * No data available</h4>{" "}
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            referalListings?.map((listing, index) => {
                                                                const referalType =
                                                                    listing.referral_type != null
                                                                        ? listing.referral_type
                                                                        : "seller";
                                                                return (
                                                                    <tr key={index}>
                                                                        <td className="edit">{index + 1}</td>
                                                                        <td className="edit">
                                                                            {listing.client_name +
                                                                                " " +
                                                                                listing.client_lastname}
                                                                        </td>
                                                                        {/* <td className="edit">
                                                                            {listing.client_email}
                                                                        </td> */}
                                                                        <td className="edit">
                                                                            {listing.client_phone}
                                                                        </td>
                                                                        <td className="edit">
                                                                            {listing.referral_type != null
                                                                                ? listing.referral_type
                                                                                : "seller"}
                                                                        </td>
                                                                        <td className="edit">
                                                                            {Object.keys(listing.listing_data)
                                                                                .length > 0
                                                                                ? referalType === "seller"
                                                                                    ? listing.listing_data?.listing_number
                                                                                    : listing.listing_data?.request_nb
                                                                                : "N/A"}
                                                                        </td>
                                                                        <td className="edit">
                                                                            <Link
                                                                                type="button"
                                                                                name=""
                                                                                className="view-member"
                                                                                to={`/view-referals/${listing?.id}`}
                                                                            >
                                                                                <img
                                                                                    src={VIEWLISTING}
                                                                                    alt="view listing"
                                                                                />
                                                                            </Link>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </section>
                <Footer/>
        </>
    );
};

export default ReferalListings;
